module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Upload_16"],"path":[{"$":{"d":"M10,11v4H6V11H3.5L8,5l4.5,6Zm1-8h2V1H11ZM7,3H9V1H7ZM3,3H5V1H3Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Upload_16.svg
// module id = +tgq
// module chunks = 1